export default "__VITE_ASSET__DlsGz0f7__"